import React, { useState } from 'react';
import {
  Box,
  Container,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import {
  TrendingUp as SalesIcon,
  TrendingDown as ExpensesIcon
} from '@mui/icons-material';
import SalesStats from './SalesStats';
import ExpensesStats from './ExpensesStats';

const StatsView = ({ storeId }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', bgcolor: 'background.default', minHeight: '100vh' }}>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Paper 
          elevation={0} 
          sx={{ 
            mb: 3, 
            borderRadius: 3,
            overflow: 'hidden',
            border: '1px solid',
            borderColor: 'divider'
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              bgcolor: 'background.paper',
              '& .MuiTab-root': {
                py: 2,
                fontSize: '1rem',
                fontWeight: 600,
                textTransform: 'none',
                minHeight: 64,
              },
              '& .Mui-selected': {
                color: 'primary.main',
              },
            }}
          >
            <Tab
              icon={<SalesIcon />}
              iconPosition="start"
              label="Estadísticas de Ventas"
              sx={{
                '&.Mui-selected': {
                  bgcolor: 'primary.main',
                  color: 'white !important',
                  '& .MuiSvgIcon-root': {
                    color: 'white',
                  },
                },
              }}
            />
            <Tab
              icon={<ExpensesIcon />}
              iconPosition="start"
              label="Estadísticas de Gastos"
              sx={{
                '&.Mui-selected': {
                  bgcolor: 'error.main',
                  color: 'white !important',
                  '& .MuiSvgIcon-root': {
                    color: 'white',
                  },
                },
              }}
            />
          </Tabs>
        </Paper>

        <Box>
          {activeTab === 0 && <SalesStats storeId={storeId} />}
          {activeTab === 1 && <ExpensesStats storeId={storeId} />}
        </Box>
      </Container>
    </Box>
  );
};

export default StatsView;
